import Table from "Shared/components/DataTable/Table"

const RegularDonationsWidget = () => {
  const target = useSel((s) => s.target)

  const isTargetValid = target && Object.keys(target).length > 0 && target.id

  if (!isTargetValid) {
    return <div>Loading...</div>
  }

  return (
    <>
      <p className="larger bold no-margin-top">Regular Donations</p>
      <Table
        table="regularDonations"
        language={{ emptyTable: "No regular donations found." }}
        scope={{ target_id: target.id }}
        hideSearch={true}
      />
    </>
  )
}

export default RegularDonationsWidget
